import { useState, useEffect } from "react";
import { getStrapiResponse } from "../../utils/utils";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { Pages_Plain } from "../../types/api/page.ts";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "../../components/Pages/Pages.scss";
import Page404 from "../../components/Page404/Page404.tsx";
import { updateSEO } from "../../utils/seo";

const fetchPageData = async ({
  queryKey,
}: {
  queryKey: string[];
}): Promise<Pages_Plain> => {
  const response = await getStrapiResponse(queryKey[0]);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

const Pages = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const pageUrl = `/api/pages?customPopulate=nested&filters[slug][$eq]=${
    params.slug ? params.slug : ""
  }`;
  const {
    data: pages,
    error,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [pageUrl],
    queryFn: fetchPageData,
  });

  const page = pages?.data?.[0];

  useEffect(() => {
    updateSEO(page?.seo); // Canonical will be set even if seo is undefined
  }, [page]);

  if (isLoading) return <div className="loading-block"></div>;
  if (isError) return <div>Error: {error.message}</div>;
  if (!pages) return <div>Global error: {pages}</div>;
  if (!pages.data.length) {
    navigate("/", { replace: true });
    return <Page404 locale={""} />;
  }

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  return (
    <>
      <div className="content-block">
        <div className="text-page">
          <div className="wrapper">
            <h1>{page?.title}</h1>
            <div className="tabs">
              <div className="tabs-nav">
                {page?.tabs.map((tab, index) => (
                  <div
                    className={`tabs-nav__item ${activeTab === index ? "active" : ""}`}
                    onClick={() => handleTabClick(index)}
                    data-index={index}
                  >
                    <a href={`#${tab.id}`}>{tab.title}</a>
                  </div>
                ))}
              </div>
              <div className="tabs-content">
                <div className="text-page__cont">
                  <Markdown remarkPlugins={[remarkGfm]}>
                    {page?.tabs[activeTab]?.text}
                  </Markdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pages;
